/**
 * @generated SignedSource<<209b38298686a6b3a1e24e00e31d8d21>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type VocabularySource = "ASKED" | "CORRECTED" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ProgressViewWords_learner$data = {
  readonly id: string;
  readonly vocabularyItems: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly firstMetAt: any;
        readonly source: VocabularySource;
      };
    }>;
  };
  readonly " $fragmentType": "ProgressViewWords_learner";
};
export type ProgressViewWords_learner$key = {
  readonly " $data"?: ProgressViewWords_learner$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProgressViewWords_learner">;
};

import ProgressViewWordsPaginationQuery_graphql from './ProgressViewWordsPaginationQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "vocabularyItems"
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": 100,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cursor"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "since"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": (v0/*:: as any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "count",
          "cursor": "cursor"
        },
        "backward": null,
        "path": (v0/*:: as any*/)
      },
      "fragmentPathInResult": [
        "node"
      ],
      "operation": ProgressViewWordsPaginationQuery_graphql,
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "ProgressViewWords_learner",
  "selections": [
    {
      "alias": "vocabularyItems",
      "args": [
        {
          "kind": "Variable",
          "name": "since",
          "variableName": "since"
        }
      ],
      "concreteType": "VocabularyItemConnection",
      "kind": "LinkedField",
      "name": "__ProgressView_vocabularyItems_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "VocabularyItemEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "VocabularyItem",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "firstMetAt",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "source",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "Learner",
  "abstractKey": null
};
})();

(node as any).hash = "bb239ac6a6f8b1229f9bf702936e58ab";

export default node;
